import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "../../assets/css/modal.css";
import "./Menu.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { checkEmail } from "../../actions/userActions";
import menuLogo from "../../assets/svgs/menu-logo.svg";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const MenuModal = ({ show, closeModal }) => {

  const [newUserName, setNewUserName] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.headers) {
      var username = JSON.parse(window.localStorage.getItem("headers"));

      dispatch(checkEmail(username.data.user.email, true));
      var newname = username.data.user.fname + " " + (username.data.user.lname !== null ? username.data.user.lname : '');
      setNewUserName(newname);
    }
  }, [localStorage.headers]);

  const handleClose = () => {
    localStorage.removeItem("popup");
    closeModal();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-md-mm menu res-modal"
      contentClassName="xs mm-content"
      centered
    >
      <Modal.Body className="mm-body">
        {/* Red banner top */}
        <div className="mm-banner">
          <ModalCloseButton onClick={handleClose} />
          <div className="mm-icon-ring">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
              <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
              <line x1="6" y1="1" x2="6" y2="4" />
              <line x1="10" y1="1" x2="10" y2="4" />
              <line x1="14" y1="1" x2="14" y2="4" />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="mm-card">
          <p className="mm-greeting">Welcome back,</p>
          <h2 className="mm-username">{newUserName}</h2>
          <p className="mm-subtitle">Thank you for choosing to dine with us!</p>

          <button className="mm-eat-btn" onClick={handleClose}>
            Let's eat!
          </button>

          <p className="mm-powered">Powered by Warely</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

MenuModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

// export default MenuModal;

const mapStateToProps = (state) => ({
});
export default withTranslation()(
  connect(mapStateToProps, { checkEmail })(MenuModal)
);

